export function WinnerCheckSolid({ size = 14, color = "#16a34a", ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="4 4 16 16"   // cropped from the default 0 0 24 24
      aria-label="Winner"
      role="img"
      {...rest}
    >
      <path
        d="M7 12l3 3 7-7"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}